module.exports = __webpack_public_path__ + "static/media/fabrika-lukavec-de-bondt-14-4.1a8e4a3d.JPG";